import { HorizontalPagePaddingString } from '@cfra-nextgen-frontend/shared/src/utils';
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';

type Props = {
    children: React.ReactNode;
    sx?: SxProps;
    paddingTop?: number;
    paddingBottom?: number;
};

export function ETFTabContainer({ children, sx, paddingTop = 32, paddingBottom = 72 }: Props) {
    return (
        <Box
            sx={{
                backgroundColor: '#F2F5FC',
                padding: `${paddingTop}px ${HorizontalPagePaddingString} ${paddingBottom}px ${HorizontalPagePaddingString}`,
                ...sx,
            }}>
            {children}
        </Box>
    );
}
